import React from "react";
import {
    Box,
    FormControl,
    styled,
    TextField,
    Autocomplete
} from "@mui/material";
import STQueueComponent from "../../../api/StationaryTesting/STQueue";
import STQueueForm from "./STQueueForm";
import { getMessage } from "../../../global";
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';
import { GlobalButton, GlobalSecondaryButton } from "../../styles";

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    marginBottom: "20px"
}));

const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    width: "50rem"
}));

const StyledDiv = styled('div')({
    display: 'flex',
    justifyContent: "space-between"
});

const STQueue = (props) => {

    const initialStateQueue = {
        id: undefined,
        workGroupName: "",
        isActive: false,
    };

    const validationsInitialState =
    {
        workGroupName: "",
    };

    const [isAdd, setIsAdd] = React.useState(false);
    const [infoData, setInfoData] = React.useState(initialStateQueue);
    const [queueList, setQueueList] = React.useState(null);
    const [invalidField, setInvalidField] = React.useState(validationsInitialState);

    const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
    const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
    const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
    const [modalSimpleText, setModalSimpleText] = React.useState('');

    const { hasAnyRole } = useAuth();
    const canEdit = hasAnyRole([Roles.StationaryTestingSME, Roles.Developer]);

    function closeModalSimpleButton() {
        setModalSimpleButton(false);
    }

    function openModalSimpleButton(title, text, buttonText) {
        setModalSimpleButtonText(buttonText)
        setModalSimpleButton(true);
        setModalSimpleTitle(title);
        setModalSimpleText(text);
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (!validateFields()) {
            if (infoData.id !== undefined)
                saveQueue();
            else {

                STQueueComponent.get(infoData.workGroupName).then((queueExists) => {
                    if ((queueExists !== undefined && queueExists !== null))
                        openModalSimpleButton('Fail', 'This stand type name already exist', 'Ok');
                    else saveQueue();
                });
            }
        }
    }

    function saveQueue() {

        let queue = new STQueueComponent({
            workGroupName: infoData.workGroupName,
            isActive: infoData.isActive
        });

        if (infoData.id === undefined) {
            STQueueComponent.add(queue).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Queue saved with success', 'Ok');
                    loadQueueFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        } else {
            STQueueComponent.update(queue).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Queue updated with success', 'Ok');
                    loadQueueFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        }
    }

    function handleChangeIsAdd() {
        setIsAdd(true);
        resetForm();
    }


    function loadQueueFilter() {
        STQueueComponent.getAll().then((res) => {
            if (res.length > 0) {

                let array = [];
                array.push({ id: undefined, workGroupName: "" });
                array.push(...res);

                setQueueList(array);
            }
        });
    }

    function validateFields() {
        let requiredQueueName = infoData.workGroupName === "" ? getMessage('REQUIRED_FIELD') : "";

        setInvalidField({
            ...invalidField,
            workGroupName: requiredQueueName
        });

        return ((requiredQueueName !== ""));
    }

    function resetForm() {

        setInfoData(initialStateQueue);
        setInvalidField(validationsInitialState);
    }

    function handleChangeSTQueueFilter(idSelected) {
        setInfoData(initialStateQueue);

        setInfoData(() => ({
            ...initialStateQueue,
            id: idSelected,
            workGroupName: idSelected
        }));

        setIsAdd(true);

        setInvalidField(validationsInitialState);

        if (idSelected !== "") {
            STQueueComponent.get(idSelected).then((queue) => {
                if (queue !== null) {

                    setInfoData(() => ({
                        ...infoData,
                        id: idSelected,
                        workGroupName: queue.workGroupName,
                        isActive: queue.isActive,
                    }));
                }
            });
        }
    }

    React.useMemo(() => {
        if (queueList === null) {
            loadQueueFilter();
        }
    }, [queueList])

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <StyledDiv>
                    <div>
                        <StyledBox>
                            <StyledFormControl sx={{ m: 1, width: "35rem" }} variant='outlined'>

                                <StyledBox sx={{ justifyContent: "space-between" }}>
                                    <Autocomplete
                                        noOptionsText={"Loading Queue..."}
                                        value={infoData.workGroupName === '' ? null : infoData.workGroupName}
                                        onChange={(e, value) => {
                                            handleChangeSTQueueFilter(value);
                                        }}
                                        disablePortal
                                        options={queueList ? queueList.map((queue) => queue.workGroupName) : []}
                                        sx={{ width: "35rem" }}
                                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" margin="none" label="Queue" />}
                                        autoSelect
                                    />

                                    <GlobalSecondaryButton sx={{ width: "8rem", marginLeft:"1rem" }}
                                        variant='contained'
                                        type="button"
                                        onClick={handleChangeIsAdd}
                                    >Add New</GlobalSecondaryButton>

                                </StyledBox>

                            </StyledFormControl>

                        </StyledBox>

                        {isAdd === true && <STQueueForm
                            infoData={infoData} setInfoData={setInfoData}
                            invalidField={invalidField}
                            handleChangeSTQueueFilter={handleChangeSTQueueFilter}
                            canEdit={canEdit}
                        >
                        </STQueueForm>}

                        {
                            isAdd === true &&
                            <div>
                                <StyledBox sx={{ mb: 1, mt: 2, justifyContent: "space-between" }}>
                                    <GlobalButton sx={{ width: "8rem" }}
                                        variant='contained'
                                        type="submit"
                                        disabled={!canEdit}>Save</GlobalButton>
                                </StyledBox>
                            </div>
                        }

                    </div>

                </StyledDiv>

            </form >

            <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
                <label>
                    {modalSimpleText}
                </label>
            </ModalSimpleButton>

        </div >
    )
}

export default STQueue;